// A dictionary for the Scheduler Keys used by the application
export const BOKUN_SYNC_SCHEDULER_KEY = 'BOKUN_SYNC_SCHEDULER';
export const TOUR_BOOKINGS_SYNC_SCHEDULER_KEY = 'BOOKING_TOUR_SYNC_SCHEDULER';
export const AIRPORT_TRANSFER_BOOKINGS_SYNC_SCHEDULER_KEY = 'BOOKING_AIRPORT_TRANSFER_SYNC_SCHEDULER';
